// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","order-success":"OrderSuccess_order-success__XwEaq"};